(() => {
  angular
    .module('gm.common.location', [])
    .factory('GmyLocation', GmyLocation);

  function GmyLocation(
    gmApi
  ) {
    'ngInject';

    const _location = {};

    return {
      getLocation,
      load,
    };

    function getLocation() {
      return _location;
    }

    function load() {
      return gmApi.get('geo/locale')
        .then((data) => {
          _location.locales = data.locales;

          if (data.country) {
            _location.countryCode = data.country;
          } else if (data.locales.length > 0 && data.locales[0].country) {
            _location.countryCode = data.locales[0].country;
          } else {
            return gmApi
              .get('geo')
              .then((geoData) => {
                Object.keys(geoData).forEach((key) => {
                  _location[key] = geoData[key];
                });
              });
          }

          return false;
        });
    }
  }
})();
